"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * Follows the device's light/dark appearance unless the person picked one in
 * Settings → Appearance.
 *
 * `hiive-theme` in localStorage holds only an EXPLICIT choice: next-themes
 * writes it from `setTheme` and nowhere else, so nobody who never touched the
 * old Light Mode switch (or the admin/queen toggle) has a stored value, and
 * they move to "system" with no migration. A stored "light" or "dark" is a
 * real tap and keeps winning. "system" is stored when someone goes back to
 * following the device.
 *
 * next-themes injects a blocking inline script that resolves the class from
 * storage + `prefers-color-scheme` before first paint, and listens to the
 * media query, so an OS switch (or iOS auto appearance at sunset) restyles the
 * running app live.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      disableTransitionOnChange
      enableSystem
      storageKey="hiive-theme"
    >
      {children}
    </NextThemesProvider>
  );
}
